var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallbackReminderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 14,
    fill: "#F3F0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2559_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4124 34.25C24.5733 34.5287 24.8047 34.7601 25.0834 34.921C25.3621 35.0819 25.6782 35.1666 26 35.1666C26.3218 35.1666 26.638 35.0819 26.9166 34.921C27.1953 34.7601 27.4268 34.5287 27.5877 34.25",
    stroke: "#6557FF",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1666 22.334C35.1666 20.2257 34.4333 18.3923 33.3333 16.834",
    stroke: "#6557FF",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9902 29.0495C17.8705 29.1807 17.7915 29.344 17.7628 29.5193C17.7341 29.6946 17.757 29.8745 17.8286 30.0371C17.9003 30.1997 18.0177 30.3379 18.1665 30.435C18.3153 30.5321 18.4891 30.5839 18.6667 30.584H33.3334C33.511 30.584 33.6849 30.5325 33.8338 30.4356C33.9827 30.3387 34.1002 30.2006 34.172 30.0381C34.2439 29.8757 34.267 29.6958 34.2385 29.5205C34.2101 29.3451 34.1313 29.1818 34.0117 29.0504C32.7926 27.7937 31.5001 26.4581 31.5001 22.334C31.5001 20.8753 30.9206 19.4763 29.8892 18.4449C28.8577 17.4134 27.4588 16.834 26.0001 16.834C24.5414 16.834 23.1424 17.4134 22.111 18.4449C21.0795 19.4763 20.5001 20.8753 20.5001 22.334C20.5001 26.4581 19.2066 27.7937 17.9902 29.0495Z",
    stroke: "#6557FF",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 16.834C17.5666 18.3923 16.8333 20.2257 16.8333 22.334",
    stroke: "#6557FF",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2559_163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallbackReminderIcon);
export default __webpack_public_path__ + "static/media/callback-reminder-icon.5f0585037d7cf5bf549afbd1a56e7454.svg";
export { ForwardRef as ReactComponent };